export default function Hero() {
  return (
    <section id="inicio" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Fondo con gradiente */}
      <div className="absolute inset-0 bg-gradient-to-br from-pink-400 via-pink-500 to-purple-600">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      </div>

      {/* Elementos decorativos flotantes */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-pink-300/20 rounded-full blur-3xl"></div>
      <div className="absolute top-40 right-20 w-40 h-40 bg-purple-300/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-32 left-1/4 w-24 h-24 bg-pink-200/20 rounded-full blur-2xl"></div>
      <div className="absolute bottom-20 right-1/3 w-36 h-36 bg-purple-200/20 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Contenido izquierdo */}
          <div className="text-left space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight">
                Potencio tu marca en redes sociales
              </h1>
              <p className="text-4xl md:text-6xl font-script text-pink-100 italic">
                con estrategia, creatividad y resultados
              </p>
            </div>

            <p className="text-xl text-white/90 leading-relaxed max-w-xl">
              Community Manager & Social Media Manager – PatyPublicidad
            </p>

            <div className="flex flex-wrap gap-4 pt-4">
              <a
                href="#contacto"
                className="px-8 py-4 bg-white text-purple-700 font-semibold rounded-full shadow-lg shadow-pink-500/30 hover:shadow-xl hover:scale-105 transition-all cursor-pointer whitespace-nowrap"
              >
                Trabaja conmigo
              </a>
              <a
                href="#contacto"
                className="px-8 py-4 border-2 border-white text-white font-semibold rounded-full hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
              >
                Agenda tu asesoría
              </a>
            </div>
          </div>

          {/* Imagen derecha */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://public.readdy.ai/ai/img_res/1e92dc505a6a78662c5320e9c8f5c493.jpg"
                alt="Social Media Marketing"
                className="w-full h-auto rounded-3xl"
              />
            </div>
            {/* Iconos flotantes decorativos */}
            <div className="absolute -top-4 -right-4 w-16 h-16 bg-white rounded-2xl shadow-xl flex items-center justify-center animate-bounce">
              <i className="ri-instagram-line text-3xl text-pink-500"></i>
            </div>
            <div className="absolute top-1/3 -left-4 w-14 h-14 bg-white rounded-2xl shadow-xl flex items-center justify-center animate-pulse">
              <i className="ri-tiktok-line text-2xl text-purple-600"></i>
            </div>
            <div className="absolute bottom-20 -right-6 w-12 h-12 bg-white rounded-2xl shadow-xl flex items-center justify-center">
              <i className="ri-facebook-circle-line text-2xl text-pink-500"></i>
            </div>
          </div>
        </div>
      </div>

      {/* Indicador de scroll */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-white rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
